import React, { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

function AreaGraph({ data }) {
  useEffect(() => {
    if (data?.length !== 0) {
      data?.sort(function (a, b) {
        return a.month - b.month;
      });
      Results(AllModuleInfo.currentMonth.substring(0, 3));
    }
  }, [data]);
  const { AllModuleInfo } = useSelector((state) => state.billing);
  const { color_palettes } = useSelector((state) => state.palettes);
  const [graphdata, setGraphData] = useState([]);
  function Results(month) {
    const arr = [];
    const arr1 = [];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const index1 = data.findIndex((ele) => ele.name === month);
    const index = months.findIndex((ele) => ele === month);
    var previousmon = "";
    if (index1 === -1) {
      previousmon = months[index - 1];
    } else {
      previousmon = months[index];
    }
    const num = data.filter((ele) => ele.name === previousmon);
    data.forEach((ele, i) => {
      if (num[0].month < ele.month) {
        arr.push(ele);
      } else {
        arr1.push(ele);
      }
    });
    setGraphData([...arr, ...arr1]);
  }
  const labelStyle = {
    fontSize: 10,
    fontWeight: 500,
    fill: "#ADADAD", // Color of the label text
    lineHeight: 10,
    textAlign: "center",
  };

  setTimeout(function () {
    const tickLines = document.querySelectorAll(
      ".recharts-cartesian-axis-tick-line"
    );

    tickLines.forEach((tickLine) => {
      tickLine.style.display = "none";
    });
  }, 10);

  return (
    <div className="py-1">
      <ResponsiveContainer width="100%" height={260}>
        <AreaChart
          width={1000}
          height={260}
          data={graphdata}
          margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 0,
          }}
        >
          <defs>
            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={color_palettes?.[500]} stopOpacity={0.3} />
              <stop offset="95%" stopColor={color_palettes?.[500]} stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="name" tick={{ ...labelStyle }} />
          <YAxis axisLine={false} tick={{ ...labelStyle }} />
          <Tooltip />
          <Area
            dataKey="Booking"
            stroke={color_palettes?.[500]}
            fillOpacity={1}
            fill="url(#colorUv)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

export default AreaGraph;
